import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  choose(event) {
    const { provider } = event.currentTarget.dataset
    this.closeDialog("channel-picker-dialog")
    this.openDialog(`connect-dialog-${provider}`)
  }

  reconnect(event) {
    const { provider } = event.currentTarget.dataset
    this.openDialog(`connect-dialog-${provider}`)
  }

  openDialog(id) {
    this.dialogController(id)?.open()
  }

  closeDialog(id) {
    this.dialogController(id)?.dismiss()
  }

  dialogController(id) {
    const element = document.getElementById(id)
    return element && this.application.getControllerForElementAndIdentifier(element, "ruby-ui--dialog")
  }
}
